import { render } from "./splitScreen.vue?vue&type=template&id=4ca03382&scoped=true"
import script from "./splitScreen.vue?vue&type=script&lang=js"
export * from "./splitScreen.vue?vue&type=script&lang=js"

import "./splitScreen.vue?vue&type=style&index=0&id=4ca03382&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca03382"]])

export default __exports__